// Spanish translations
export default {
  welcome: 'Bienvenido',
  tapToUnmute: 'Toca para activar el sonido',
  likeHint: 'Dale me gusta si te gustó',
  previousEpisode: 'Anterior',
  nextEpisode: 'Siguiente',
};

